import React, { useState } from 'react';

const SurveyPopup = ({ onClose, questions }) => {
  const [answers, setAnswers] = useState({});

  const handleChange = (id, value) => {
    setAnswers(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = () => {
    const result = questions.map(q => ({
      id: q.id,
      answer: answers[q.id] || ''
    }));
    onClose(result); // Return collected answers to parent
  };
  const onCloseCross = () => {
    onClose([]);
  };


  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <div className="flex justify-between">
          <h2 className='text-lg lg:text-xl inter-600 mb-3 pr-2'>Please take a quick survey to help us improve better!</h2>
          <span className='survy-cross-popup cursor-pointer' onClick={() => onCloseCross(null)}>
            <img className='w-7 invert brightness-[65%]' src='../images/cross-icon.svg' alt='cross icon' />
          </span>
        </div>
        {questions.map((question) => (
          <div key={question.id} style={{ marginBottom: '1.5rem' }}>
            <p className='text-base lg:text-lg inter-500 mb-4 pb-2'>{question.primary_text}</p>

            {question.type === 'RATING' && (
              <div className='survy-pop-radio flex items-center flex-wrap justify-between'>
                {(() => {
                  const option1 = parseInt(question.option1);
                  const option2 = parseInt(question.option2);
                  return Array.from({ length: option2 - option1 + 1 }, (_, i) => {
                    const value = option1 + i;
                    return (
                      <div key={value} className='customer-radio-sngl w-1/3 md:w-auto mb-4 lg:mb-0'>
                        <input
                          type="radio"
                          name={`rating-${question.id}`}
                          id={`rating-${value}`}
                          value={value}
                          onChange={() => handleChange(question.id, value)}
                        />
                        <label htmlFor={`rating-${value}`}>
                          {value}
                        </label>
                      </div>
                    );
                  });
                })()}
              </div>
            )}


            {question.type === 'FREE_TEXT' && (
              <textarea
                className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300'
                rows="3"
                style={{ width: '100%' }}
                onChange={(e) => handleChange(question.id, e.target.value)}
              />
            )}
          </div>
        ))}

        <button onClick={handleSubmit} className='w-max bg-tertiary hover:bg-black flex items-center justify-center px-8 h-8 2xl:h-12 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow lg:mt-8'>Submit</button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  popup: {
    background: '#fff',
    padding: 20,
    borderRadius: 8,
    minWidth: 400,
    maxWidth: 600,
    textAlign: 'left',
  }
};

export default SurveyPopup;
